import Header from "../../../Components/clubDashboard/Header/Header";
import combinedServices from "../../../shared/services/user-service";
import React, { useState, useEffect } from "react";
import getLocalData from "../../../shared/localStorage/getData";
import SearchPage from "../../../Components/clubDashboard/Header/SearchPage";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import getRemoveData from "../../../shared/localStorage/removeData";
import { Link } from "react-router-dom";
import RaceAdministratorList from "./RaceAdministratorList";
import RaceClubOfficerList from "./RaceClubOfficerList";

// ✅ Recoil
import { useRecoilState } from "recoil";
import {
  clubUserDetailsAtom,
  userRaceClubOfficerClubAtom,
  userDistrictsAtom,
} from "../../../recoil/atoms/userAtoms";

const Dashboard = () => {
  const [clubUserDetails, setUserClubDetail] = useRecoilState(clubUserDetailsAtom);
  const [userRaceClubOfficerClub, setUserRaceClubOfficerClub] = useRecoilState(userRaceClubOfficerClubAtom);
  const [userDistricts, setUserDistricts] = useRecoilState(userDistrictsAtom);

  const [clubMemberDetails, setClubMemberDetails] = useState([]);
  const [totalClubMember, setTotalClubMember] = useState(0);
  const [isLoder, setIsLoder] = useState(true);
  const [user, setUser] = useState("active");
  const [isActive, setActive] = useState(false);
  const [raceAdmins, setRaceAdmins] = useState([]);
  const [showAdmins, setShowAdmins] = useState(false);
  const [showAdminsResponsive, setShowAdminResponsive] = useState(false);
  const [districtId, setDistrictId] = useState();
  const [raceClubOfficers, setRaceClubOfficers] = useState([]);
  const [showRaceClubOfficers, setShowRaceClubOfficers] = useState(false);
  const [selectedClubId, setSelectedClubId] = useState(null);
  const [showraceClubOfficerResponsive, setShowraceClubOfficerResponsive] = useState(false);
  const [userId, setUserId] = useState(null);

  const race_icon1 = "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/logo.png";

  const handleLogout = () => {
    getRemoveData("user_info");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchData = async () => {
      let userId = "";
      if (getLocalData("user_info", "isLogin")) {
        userId = getLocalData("user_info", "all").userData.login_user_detail.data.user.id;
      }
      setUserId(userId);

      try {
        const totalClubMemberRes = await combinedServices.tokenMemberCount();
        if (totalClubMemberRes.status === 401) {
          swal(totalClubMemberRes.msg, "Please Re-login", "warning").then(() => {
            getRemoveData("user_info");
            localStorage.clear();
            window.location.href = "/login";
          });
        }
        setTotalClubMember(totalClubMemberRes.data.clubMembersTotal);
      } catch (err) {
        console.error("Error fetching dashboard data", err);
      }

      setIsLoder(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (clubUserDetails.length > 0 && clubMemberDetails.length === 0) {
      combinedServices.getClubMembers(clubUserDetails[0].club.id)
        .then((res) => setClubMemberDetails(res.data))
        .catch((err) => console.error("Error fetching club members", err));
    }
  }, [clubUserDetails]);

  const handleClubMember = async (clubId) => {
    const clubResponse = await combinedServices.getClubMembers(clubId);
    setClubMemberDetails(clubResponse.data);
    setShowAdmins(false);
    setShowRaceClubOfficers(false);
  };

  const toggleClass = () => setActive(!isActive);
  const handleMemberFilter = (e) => setUser(e.target.value);

  const fetchRaceAdministrators = async (district_id) => {
    try {
      const response = await combinedServices.getRaceAdministratorsByDistrict({ district_id });
      setRaceAdmins(response?.data);
      setShowAdmins(true);
    } catch (err) {}
  };

  const fetchRaceClubOfficers = async (club_id) => {
    try {
      const response = await combinedServices.getRaceClubOfficersByClubId(club_id);
      setRaceClubOfficers(response?.data);
      setShowAdmins(false);
      setShowRaceClubOfficers(true);
    } catch (err) {}
  };

  const handleEditClubClick = (clubId) => {
    window.location.href = `/edit-club/${clubId}`;
  };

  return (
    <>
      <Header />
      <div className="dbRight">
        <div className="dbMid">
          <SearchPage />

          <div className="">
            <div className="dbMainHd">My Clubs</div>
            {isLoder && clubUserDetails.length==0 ? (
              <div className="text-center mt-4 loadMore">
                <Spinner color="primary" />
              </div>
            ) : (
              <>
                <ul className="myClubList" style={{ display: "contents" }}>
                  {clubUserDetails.map((clubInfo) => (
                    <li
                      key={clubInfo.club.id}
                      onClick={() => handleClubMember(clubInfo.club.id)}
                    >
                      <div className="left">
                        <a href="#">
                          <img src={race_icon1} alt="" />
                          {clubInfo.club.club_name}
                        </a>
                      </div>
                      <div className="rgt">
                        <div className="district">
                          District: {clubInfo.club.club_district}
                        </div>
                        {clubInfo.club.founder && (
                          <div className="name">
                            <span>
                              {clubInfo.club.founder.user_firstname +
                                " " +
                                clubInfo.club.founder.user_lastname}
                            </span>{" "}
                            ({clubInfo.club.founder.user_areacodemobile}){" "}
                            {clubInfo.club.founder.user_mobile}
                          </div>
                        )}
                        <div className="button-group">
                          <div className="btn" style={{ margin: "auto" }}>
                            {clubInfo.club.club_status}
                          </div>
                          <div className="viewDet">
                            <a href="#" className="action-button">
                              View Detail
                            </a>
                          </div>
                        </div>

                        {clubInfo.club.founder.id == userId && (
                          <div className="button-group">
                            <div
                              className="viewDet"
                              onClick={(e) => {
                                e.stopPropagation();
                                fetchRaceClubOfficers(clubInfo.club.id);
                                setSelectedClubId(clubInfo.club.id);
                                setShowraceClubOfficerResponsive("active");
                              }}
                            >
                              <a href="#" className="action-button">
                                Manage Race Administrators
                              </a>
                            </div>
                            <div
                              className="viewDet"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditClubClick(clubInfo.club.id);
                              }}
                            >
                              <a href="#" className="action-button">
                                Edit Club Details
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  ))}

                  {userRaceClubOfficerClub.map((clubInfo) => (
                    <li
                      key={clubInfo.club.id}
                      onClick={() => handleClubMember(clubInfo.club.id)}
                      style={{ position: "relative" }}
                    >
                      <div className="ribbon">Race Admin</div>
                      <div className="left">
                        <a href="#">
                          <img src={race_icon1} alt="" />
                          {clubInfo.club.club_name}
                        </a>
                      </div>
                      <div className="rgt">
                        <div className="district">
                          District: {clubInfo.club.club_district}
                        </div>
                        {clubInfo.club.founder && (
                          <div className="name">
                            <span>
                              {clubInfo.club.founder.user_firstname +
                                " " +
                                clubInfo.club.founder.user_lastname}
                            </span>{" "}
                            ({clubInfo.club.founder.user_areacodemobile}){" "}
                            {clubInfo.club.founder.user_mobile}
                          </div>
                        )}
                        <div className="button-group">
                          <div className="btn" style={{ margin: "auto" }}>
                            {clubInfo.club.club_status}
                          </div>
                          <div className="viewDet">
                            <a href="#" className="action-button">
                              View Detail
                            </a>
                          </div>
                        </div>
                        {clubInfo.club.founder.id == userId && (
                          <div className="button-group">
                            <div
                              className="viewDet"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditClubClick(clubInfo.club.id);
                              }}
                            >
                              <a href="#" className="action-button">
                                Edit Club Details
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </li>
                  ))}

                  {clubUserDetails.length === 0 &&
                    userRaceClubOfficerClub.length === 0 && (
                      <li key="error">
                        <div className="left">Not found any club</div>
                        <div className="rgt"></div>
                      </li>
                    )}
                </ul>
              </>
            )}
          </div>

          {userDistricts?.length > 0 && (
            <div>
              <div className="dbMainHd">My Districts</div>
              <ul className="myClubList" style={{ display: "contents" }}>
                {userDistricts.map((d) => (
                  <li key={d.district_id}>
                    <div className="left">
                      <a href="#">
                        <img src={race_icon1} alt="" />
                        District {d.districtdirector_d_d_district_number}
                      </a>
                    </div>
                    <div className="rgt">
                      <div className="district">
                        District: {d.districtdirector_d_d_district_number}
                      </div>
                      <div className="name">
                        <span>
                          {d.u_user_firstname + " " + d.u_user_lastname}
                        </span>{" "}
                        ({d.u_user_areacodemobile}) {d.u_user_mobile}
                      </div>
                      <div className="viewDet">
                        <a
                          href="#"
                          onClick={() => {
                            fetchRaceAdministrators(d.district_id);
                            setDistrictId(d.district_id);
                            setShowAdminResponsive("active");
                          }}
                          className="action-button"
                        >
                          Manage Race Administrators
                        </a>
                        <Link
                          to={`/canons-of-conduct/${d.district_id}`}
                          className="action-button"
                        >
                          Canons of Conduct
                        </Link>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Conditional Panels */}
      {showAdmins ? (
        <RaceAdministratorList
          raceAdministratorList={raceAdmins}
          district_id={districtId}
          showAdminsResponsive={showAdminsResponsive}
          setShowAdminResponsive={setShowAdminResponsive}
        />
      ) : showRaceClubOfficers ? (
        <RaceClubOfficerList
          raceClubOfficerList={raceClubOfficers}
          club_id={selectedClubId}
          showraceClubOfficerResponsive={showraceClubOfficerResponsive}
          setShowraceClubOfficerResponsive={setShowraceClubOfficerResponsive}
          refreshClubOfficers={() => fetchRaceClubOfficers(selectedClubId)}
        />
      ) : (
        <div className="myRace">
          <div className="userName member">
            <span
              className={isActive ? "showRace active" : "showRace"}
              onClick={toggleClass}
            >
              <i className="hide">Hide</i> <i className="show">Show</i> My
              Members
            </span>
          </div>
          <div
            id="myRaces"
            className={isActive ? "raceListBox active" : "raceListBox"}
          >
            <div className="myRaceHd">My Members</div>
            <div className="flexBox nowrap itemCenter districtSelectBox">
              <select onChange={handleMemberFilter} name="user" value={user}>
                <option key="1" value="active">Active</option>
                <option key="2" value="inactive">Inactive</option>
              </select>
            </div>
            {clubMemberDetails && clubMemberDetails.length > 0 ? (
              clubMemberDetails
                .filter((member) =>
                  user === "active"
                    ? member.user?.user_status === "active"
                    : member.user?.user_status === "inactive"
                )
                .sort((a, b) =>
                  (a.user?.user_lastname || "").localeCompare(
                    b.user?.user_lastname || ""
                  )
                )
                .map((member) =>
                  member.user && member.nambanumber ? (
                    <ul key={member.user.id} className="memberList" style={{ display: "contents" }}>
                      <li>
                        <a className="flexBox nowrap itemCenter spacebetween">
                          <span className="name">
                            {member.user.user_firstname +
                              " " +
                              member.user.user_lastname}
                          </span>
                          <span className="count">
                            {member.nambanumber.num_number}
                          </span>
                        </a>
                      </li>
                    </ul>
                  ) : null
                )
            ) : (
              <div>No club members available</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
